<template>
  <div class="bottom">    
    <div class="bottom-m">
      <div class="name">学习情况统计</div>
      <div id="studyChart" :style="{ width: '100%', height: '400px' }"></div>
    </div>

    <div class="bottom-L">
      <div class="name">行业统计</div>
      <div id="chart" :style="{ width: '100%', height: '400px' }"></div>
    </div>

    <div class="bottom-R">
      <div class="name">专业课证书</div>
      <div id="funnel_a" :style="{ width: '100%', height: '400px' }"></div>
    </div>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
export default {
  name: "BottomSet",
  data() {
    return {
      list: 0,
      xAxisData: [], // 专业课证书
      seriesData: [],
      studyxAxisData: null, // 学习情况统计
      studyseriesData: null,
      hyxAxisData: [], // 行业统计
      baryears:[],
      hyseriesData: [],
      mouths:[],
      wAxis2018:[], // 已报名
      wAxis2019:[],
      wAxis2020:[],
      wAxis2021:[],
      wAxis2022:[],
      Axis2018:[], // 学习情况数据通用
      Axis2019:[],
      Axis2020:[],
      Axis2021:[],
      Axis2022:[],
    };
  },
  methods: {
    // 切换已完成和已报名
    // changeBg (index) {
    //   if (index === 0) {
    //     this.list = index
    //     this.Axis2018 = this.xAxis2018
    //     this.Axis2019 = this.xAxis2019
    //     this.Axis2020 = this.xAxis2020
    //     this.Axis2021 = this.xAxis2021
    //     this.study()
    //   } else if (index === 1) {
    //     this.list = index
    //     this.Axis2018 = this.wAxis2018
    //     this.Axis2019 = this.wAxis2019
    //     this.Axis2020 = this.wAxis2020
    //     this.Axis2021 = this.wAxis2021
    //     this.study()
    //   }
    // },

    // 获取学习数据
    getData() {      
      const url = '/qhjxjy_cms/DataStatistical!getData.action';
      const this_ = this;
      this_.axios.get(url).then(res=>{
        if(res.status === 200){
          this_.xAxisData = []
          this_.seriesData = []
          this_.studyxAxisData = null
          this_.studyseriesData = null
          this_.hyxAxisData = []
          this_.hyseriesData = []
          this_.baryears = []
          this_.mouths= []

          var dataSet = JSON.parse(res.data.certCount)
          var barDatSet = JSON.parse(res.data.industry)
          // 已完成
          var finishedCount = JSON.parse(res.data.finishedCount)
          // 已报名
          
          var enrollCount = JSON.parse(res.data.enrollCount)          
          if(enrollCount) {
            enrollCount.forEach(item => {
              if(item[0] == '2018'){
                item[1].forEach(item1 => {
                  this_.wAxis2018.push(item1[1])
                })
              }else if (item[0] == '2019'){
                item[1].forEach(item1 => {
                  this_.wAxis2019.push(item1[1])
                })
              }else if (item[0] == '2020'){
                item[1].forEach(item1 => {
                  this_.wAxis2020.push(item1[1])
                })
              }else if (item[0] == '2021'){
                item[1].forEach(item1 => {
                  this_.wAxis2021.push(item1[1])
                })
              }
              else if (item[0] == '2022'){
                item[1].forEach(item1 => {
                  this_.wAxis2022.push(item1[1])
                })
              }
            })
          }
              this_.Axis2018 = this_.wAxis2018
              this_.Axis2019 = this_.wAxis2019
              this_.Axis2020 = this_.wAxis2020
              this_.Axis2021 = this_.wAxis2021
              this_.Axis2022 = this_.wAxis2022
          
          if (dataSet) {
            dataSet.forEach(item => {
              this_.xAxisData.push(item[0])
              this_.seriesData.push(item[1])
            });
          }

          if (barDatSet) {
            var arr2018 = [];
            var arr2019 = [];
            var arr2020 = [];
            var arr2021 = [];
            var arr2022 = [];
            var arrY2018 = [];
            var arrY2019 = [];
            var arrY2020 = [];
            var arrY2021 = [];
            var arrY2022 = [];
            barDatSet.forEach(item => {
              this_.baryears.push(item[0])
              if(item[0]=='2018'){
                item[1].forEach(itemData => {
                  arr2018.push(itemData[0])
                  arrY2018.push(itemData[1])
                })
                this_.hyxAxisData.push(arr2018)
                this_.hyseriesData.push(arrY2018)
              }else if(item[0]=='2019'){
                item[1].forEach(itemData => {
                  arr2019.push(itemData[0])
                  arrY2019.push(itemData[1])
                })
                this_.hyxAxisData.push(arr2019)
                this_.hyseriesData.push(arrY2019)
              }else if(item[0]=='2020'){
                item[1].forEach(itemData => {
                  arr2020.push(itemData[0])
                  arrY2020.push(itemData[1])
                })
                this_.hyxAxisData.push(arr2020)
                this_.hyseriesData.push(arrY2020)
              }else if(item[0]=='2021'){
                item[1].forEach(itemData => {
                  arr2021.push(itemData[0])
                  arrY2021.push(itemData[1])
                })
                this_.hyxAxisData.push(arr2021)
                this_.hyseriesData.push(arrY2021)
              }
              else if(item[0]=='2022'){
                item[1].forEach(itemData => {
                  arr2022.push(itemData[0])
                  arrY2022.push(itemData[1])
                })
                this_.hyxAxisData.push(arr2022)
                this_.hyseriesData.push(arrY2022)
              }
            });
          }
          this.barChart();
          this.certificate();
          this.study();

        }
      })
      // var backData = JSON.parse(sessionStorage.getItem('backData'))
      
    },
    getRidPerCent(ord) {
      let num = null;
      num = Number(ord.split("%").join(""));
      return num;
    },

    // 行业
    barChart(data) {
      let chart = echarts.init(document.getElementById("chart"));
      var dataAxis = [];
      var yAxisData = [];
      var years = ['2018', '2019', '2020','2021','2022'];
      var data = [["XX公司", "XX公司", "XX公司"],["XX公司", "XX公司"],["XX公司", "XX公司", "XX公司", "XX公司"],["XX公司", "XX公司"],["XX公司", "XX公司"],];
      var data1 = [["102", "198", "123"],["3203", "598"],["303", "398", "158", "538"],["3203", "598"],["3203", "598"],];
      var opts = [];
      for (var i = 0; i < this.baryears.length; i++) {
        var conditions = [{
            'querycol_案件进展': this.baryears[i]
        }]
        opts.push({
          xAxis: [{
            "axislabel": {
                "interval": 0
            },
            data: this.hyxAxisData[i],
        }],
        series: [{
            barWidth:'10px', // 设置宽度
            type: "bar",
            itemStyle: {
              normal: {
                barBorderRadius: [30,30,0,0],
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#8f63fb" },
                { offset: 0.5, color: "#a946fd" },
                { offset: 1, color: "#a826e5" }
                ]),
              },
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#a826e5" },
                  { offset: 0.7, color: "#a946fd" },
                  { offset: 1, color: "#8f63fb" }
                ])
              }
            },
            data: this.hyseriesData[i]
          }]
        })
      }
      let option ={
        timeline: {
          axisType: 'category',
          autoPlay: true,
          playInterval: 5000,
          left: "0",
          right: "0",
          bottom: " 8%",
          padding: [15, 0],
          data: this.baryears,
        },
        grid: {
          left: "1%",
          right: "0%",
          bottom: "25%",
          containLabel: true
        },
        title: {
          //text: "行业",
          textStyle: {
            color: " #96ccff",
            fontSize: "20",
            fontWeight: "normal"
          }
        },
        tooltip: {
          // 鼠标进入显示所占比例
          trigger: "item"
        },
        xAxis: {
          type: "category",
          data: opts,
          axisLabel: {
            interval: 0, //控制x轴文字之间的间距
            rotate: 30,
            // formatter: function (value) {
            //   return value.split("").join("\n");
            // },
            formatter: function (name) {      //超出部分隐藏显示
              return (name.length > 5 ? (name.slice(0,5)+"...") : name ); 
            },
            fontSize: 10
          },
          axisTick: {
            show: true
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ccc" //这是x轴文字颜色
            }
          },
          z: 10
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "rgba(255,255,255,0.5)"
            }
          },
          splitLine: {
            lineStyle: {
              color: "#090059" // 分割线的颜色
            }
          },
          type: "value",
          // splitNumber: 20, // 控制y轴数值间距的
          // data:[200,300,800,500,900,800,10000,20564,4500]
        },
        options: opts,
        
      }
      chart.setOption(option);
    },

    // 证书
    certificate(n1, n2, n3) {
      let chart = echarts.init(document.getElementById("funnel_a"));
      var yAxisData = [n1, n2, n3];
      chart.setOption({
        grid: {
          left: "12%",
          top: "15%",
          bottom: "12%",
          right: "8%"
        },
        xAxis: {
          data: this.xAxisData,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "rgba(255, 129, 109,.1)",
              width: 1 //这里是为了突出显示加上的
            }
          },
          axisLabel: {
            textStyle: {
              color: "#999",
              fontSize: 12
            }
          }
        },
        yAxis: [
          {
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "rgba(255, 129, 109, 0.1)",
                width: 1 //这里是为了突出显示加上的
              }
            },
            axisLabel: {
              textStyle: {
                color: "#999"
              }
            },
            splitArea: {
              areaStyle: {
                color: "rgba(255,255,255,.5)"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255, 129, 109, 0.1)",
                width: 0.5,
                type: "dashed"
              }
            }
          }
        ],
        series: [
          {
            type: "pictorialBar",
            barCategoryGap: "0%",
            barWidth: '140%',
            symbol:
              "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
            label: {
              show: true,
              position: "top",
              distance: 15,
              color: "#08DFFE",
              fontWeight: "bolder",
              fontSize: 15
            },
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#9A11FF"
                    },
                    {
                      offset: 1,
                      color: "rgba(8,223,254,0.5)" //透明度
                    }
                  ],
                  global: false //  缺省为  false
                }
              },
              emphasis: {
                opacity: 1,
                
              }
            },
            data: this.seriesData
          },
        ]
      });
    },

    // 学习情况统计
    study() {
      let myChart2 = echarts.init(document.getElementById("studyChart"));
      myChart2.setOption({
        legend: {
          textStyle: {
            color: "#ffffff" //字体颜色
          },
          // y: 'center',    //延Y轴居中
          x: 'right', //居右显示
          left: "right",
          // top: "45%",
        },
        grid: {
          top: "15%",
          left: "10%",
          right: "5%",
          bottom: "5%"
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              show: true
            },
            splitArea: {
              color: "#f00",
              lineStyle: {
                color: "#f00"
              }
            },
            axisLabel: {
              color: "#fff"
            },
            axisTick: {
              show: true
            },
            splitLine: {
              show: false
            },
            boundaryGap: false,
            data: this.mouths
          }
        ],

        yAxis: [
          {
            type: "value",
            min: 0,
            // max: 140,
            splitNumber: 4,
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,0.1)"
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: "rgba(255,255,255,0.5)"
              }
            }
          }
        ],
        series: [
          {
            name: "2018",
            type: "line",
            smooth: true, //是否平滑
            showAllSymbol: true,
            symbol: "circle",
            symbolSize: 10,
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#00b3f4"
              }
            },
            itemStyle: {
              color: "#34fef2",
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0,179,244,0.3)"
                    },
                    {
                      offset: 1,
                      color: "rgba(0,179,244,0)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(0,179,244, 0.9)",
                shadowBlur: 20
              }
            },
            data: this.Axis2018
          },
          {
            name: "2019",
            type: "line",
            smooth: true, //是否平滑
            showAllSymbol: true,
            symbol: "circle",
            symbolSize: 10,
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#ff6666"
              }
            },

            itemStyle: {
              color: "#ff6666",
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(255,102,102,0.3)"
                    },
                    {
                      offset: 1,
                      color: "rgba(255,102,102,0)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(255,102,102, 0.9)",
                shadowBlur: 20
              }
            },
            data: this.Axis2019
          },
          {
            name: "2020",
            type: "line",
            smooth: true, //是否平滑
            showAllSymbol: true,
            symbol: "circle",
            symbolSize: 10,
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#55cd65"
              }
            },

            itemStyle: {
              color: "#55cd65",
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(85,205,101,0.3)"
                    },
                    {
                      offset: 1,
                      color: "rgba(85,205,101,0)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(85,205,101, 0.9)",
                shadowBlur: 20
              }
            },
            data: this.Axis2020
          },
          {
            name: "2021",
            type: "line",
            smooth: true, //是否平滑
            showAllSymbol: true,
            symbol: "circle",
            symbolSize: 10,
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#ff8b00"
              }
            },

            itemStyle: {
              color: "#ff8b00",
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(255,139,0,0.3)"
                    },
                    {
                      offset: 1,
                      color: "rgba(255,139,0,0)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(255,139,0, 0.9)",
                shadowBlur: 20
              }
            },
            data: this.Axis2021
          },
          {
            name: "2022",
            type: "line",
            smooth: true, //是否平滑
            showAllSymbol: true,
            symbol: "circle",
            symbolSize: 10,
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#df47d7"
              }
            },

            itemStyle: {
              color: "#df47d7",
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(255,139,0,0.3)"
                    },
                    {
                      offset: 1,
                      color: "rgba(255,139,0,0)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(255,139,0, 0.9)",
                shadowBlur: 20
              }
            },
            data: this.Axis2022
          },
        ]
      });
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      echarts.init(document.getElementById("chart")).resize();
    });
    window.addEventListener("resize", () => {
      echarts.init(document.getElementById("funnel_a")).resize();
    });
    window.addEventListener("resize", () => {
      echarts.init(document.getElementById("studyChart")).resize();
    });

    setInterval(() => {
      setTimeout(() => {
        console.log('重新请求了')
        this.barChart();
        this.certificate();
        this.study();
      }, 0);
    }, 1000*60*60*24);
  },
  created() {
    this.getData()
  }
};
</script>

<style scoped>
.name {
  color: #96ccff;
  font-size: 20px;
  letter-spacing: 2px;
  background-image: -webkit-linear-gradient(left, #040043, #13025e40);
  margin: -10px;
  padding: 10px;
  z-index: 99;
}
.bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.bottom >>> .el-progress__text {
  color: rgba(6, 0, 59, 1);
}

.proportion {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: center;
  height: 100%;
}
.complete {
  margin-bottom: 10px;
  color: #6f6f6f;
  font-size: 14px;
}
.left,
.midd,
.right {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.middle-child {
  padding: 10px;
  box-sizing: border-box;
  width: 46%;
}
.middle-right {
  padding: 10px;
  box-sizing: border-box;
  width: 26%;
}
.bar {
  position: absolute;
  display: flex;
  right: 0;
  top: 3%;
  transform: translate(-50%);
  width: 90px;
  justify-content: space-between;
  border: 1px solid rgb(9, 151, 207);
  z-index: 100000;
  font-size: 13px;
}
.bg {
  background: rgb(9, 151, 207);
}
.bottom-L {
  padding: 10px;
  box-sizing: border-box;
  width: 46%;
  height: 400px;
}
.bottom-m {
  height: 460px;
  margin-top: -60px;
  position: relative;
  padding: 10px;
  box-sizing: border-box;
  width: 26%;
  background: rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 0px 1px #0c0165;
  border-left: 1px transparent solid;
  border-right: 1px transparent solid;
  border-top: 2px transparent solid;
  -o-border-image: linear-gradient(to top, #130963, #130963, #130963, #2c0792) 1
    10;
  border-image: linear-gradient(to top, #130963, #130963, #130963, #2c0792) 1 10;
}
.pro,
.city {
  flex: 1;
  text-align: center;
}
.pro {
  border-right: 1px solid rgb(9, 151, 207);
}
.bottom-R {
  height: 460px;
  margin-top: -60px;
  padding: 10px;
  box-sizing: border-box;
  width: 26%;
}
.bottom-L,
.bottom-R {
  background: rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 0px 1px #0c0165;
  border-left: 1px transparent solid;
  border-right: 1px transparent solid;
  border-top: 2px transparent solid;
  border-image: linear-gradient(to top, #130963, #130963, #130963, #2c0792) 1 10;
}
.box {
  margin-top: 10px;
}
.middle-right,
.middle-child,
.middle-left {
  background: rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 0px 1px #0c0165;
  border-left: 1px transparent solid;
  border-right: 1px transparent solid;
  border-top: 2px transparent solid;
  border-image: linear-gradient(to top, #130963, #130963, #130963, #614ba4) 1 10;
}
.proChild {
  position: absolute;
  top: 50%;
  /* display: block; */
  /* background: #080147; */
  z-index: 1;
  width: 60px;
  font-size: 14px;
  text-align: center;
  border-radius: 50%;
}
/* layui 模块化 通过layui.use()加载入口文件  */
</style>  